var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vtable',{attrs:{"title":"Cases Profile","itemKey":"id","tableData":_vm.casesProfile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }